import React from 'react';
import { Form, Select, Switch, Card, Row, Col, Typography } from 'antd';
import style from '../../Styles/AddUser.module.css';
const { Option } = Select;
const { Title, Text } = Typography;

const Governance = ({
  departmentList = [],
  departmentIds = [],
  setDepartmentIds,
  approverList = [],
  approvers,
  setApprovers,
  approvalRequired,
  setApprovalRequired,
  requireAllQuestions,
  setRequireAllQuestions,
  anonymousResponse,
  setAnonymousResponse,
  allowResubmission,
  setAllowResubmission,
  isPreview = false,
}) => {
  return (
    <Card style={{ marginBottom: 20, borderRadius: 8 }}>
      <div className={style['title-style']}>Governance & Approval</div>

      <Form layout="vertical">
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Department">
            <Select
              mode="multiple"
              placeholder="Select department(s)"
              value={departmentIds}
              onChange={
                !isPreview
                  ? (value) => {
                      setDepartmentIds(value);
                      setApprovers([]);
                    }
                  : undefined
              }
              allowClear
              disabled={isPreview}
              optionFilterProp="children"
              showSearch
            >
              {departmentList?.map((dept) => (
                <Option key={dept.value} value={dept.value}>
                  {dept.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="Approver">
            <Select
              mode="multiple"
              placeholder="Select approvers"
              value={approvers}
              onChange={!isPreview ? setApprovers : undefined}
              allowClear
              disabled={
                isPreview || !departmentIds || departmentIds.length === 0
              }
              optionFilterProp="children"
              showSearch
            >
              {approverList?.map((user) => (
                <Option key={user.id} value={user.id}>
                  {user.username || user.name || user.value}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      </Form>


    </Card>
  );
};

export default Governance;
